/* js/navPrioirty.js */

jQuery(document).ready(function ($) {
    $(document).ready(function () {
        $('.navPriority__list').dropit();
    });


    $('.js_menuOpen a').click(function (e) {
        e.preventDefault();
        $('body').addClass('navPriorityOpen');
    });
    $('.js_menuClose a').click(function (e) {
        e.preventDefault();
        $('body').removeClass('navPriorityOpen');
    });
});



